import React, { useContext } from "react";

import VarietyAdd from "./variety-add";

import { TaskContext } from "contexts/task";
import VarietyItem from "./variety-item";
import { arrayToObjectByKey } from "shared/helpers";

const VarietiesTable = ({
    attributeList,
    handleClose,
    addVariety,
    removeVariety,
    updateVariety,
    varieties,
    varietyData,
    varietiesWithLinks,
    updateVarietyAttribute,
    removeVarietyAttribute,
}) => {
    const { task } = useContext(TaskContext);

    return (
        <div className="variety-packs">
            <div className="variety-table" style={{ gridTemplateRows: `85px 85px repeat(${attributeList.length}, 1fr)` }}>
                <div className="variety-info" style={{ display: "flex", border: 0 }}>
                    <button className="button" onClick={handleClose}>
                        Back
                    </button>
                    <h1>
                        Variety Packs <em className="memo">{task.fullUpc}</em>
                    </h1>
                </div>
                <VarietyAdd addVariety={addVariety} />
                {attributeList.map((attr) => {
                    return <div key={`label_${attr.uuid}`}>{attr.name}</div>;
                })}
                {Object.keys(varietyData).map((v) => {
                    return (
                        <VarietyItem
                            key={varietyData[v].code}
                            id={varietyData[v].code}
                            linkCode={varietyData[v].linkCode}
                            isParent={varietyData[v].childLinks && varietyData[v].childLinks.length > 0}
                            sharedValues={varietyData[v].sharedValues}
                            name={varietyData[v].variety}
                            referenceVariety={varietyData[v].referenceVariety}
                            packAttributes={varietyData[v].packAttributes}
                            attributeList={attributeList}
                            attributeListMap={arrayToObjectByKey(attributeList, "uuid")}
                            updateVariety={updateVariety}
                            removeVariety={removeVariety}
                            updateVarietyAttribute={updateVarietyAttribute}
                            removeVarietyAttribute={removeVarietyAttribute}
                            varieties={varieties}
                            varietiesWithLinks={varietiesWithLinks}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default VarietiesTable;
